import { render } from "./DashboardIcons.vue?vue&type=template&id=3a248628"
import script from "./DashboardIcons.vue?vue&type=script&lang=js"
export * from "./DashboardIcons.vue?vue&type=script&lang=js"

import "./DashboardIcons.vue?vue&type=style&index=0&id=3a248628&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__